import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-seat-map',
  templateUrl: './seat-map.component.html',
  styleUrls: ['./seat-map.component.css']
})
export class SeatMapComponent implements OnInit {
  @Input() stadiumImage: string;
  url: any;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl('/assets/images/stadiums/' + this.stadiumImage);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/choose-seats/seat-map/seat-map.component.ts